import { render, staticRenderFns } from "./StateHeadDashboard.vue?vue&type=template&id=2ac6b433"
import script from "./StateHeadDashboard.vue?vue&type=script&lang=js"
export * from "./StateHeadDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports